import { advantages } from '@/mocks/homeData';

export default function AdvantagesSection() {
  return (
    <section className="py-16 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-4">
            服务优势
          </span>
          <h2
            className="text-2xl md:text-3xl font-bold text-foreground-950"
            style={{ fontFamily: 'var(--font-heading)' }}
          >
            喑网91 服务优势
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            选择喑网91的四大理由 —— 我们以专业的技术实力和贴心的服务理念，赢得百万用户的信赖
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {advantages.map((item, idx) => (
            <div
              key={idx}
              className="p-6 md:p-7 rounded-2xl bg-background-50 border border-background-200/70 text-center"
            >
              <div className="w-14 h-14 mx-auto rounded-full bg-accent-100 flex items-center justify-center mb-5">
                <i className={`${item.icon} text-2xl text-accent-600`}></i>
              </div>
              <div className="text-3xl md:text-4xl font-bold text-foreground-950 mb-1" style={{ fontFamily: 'var(--font-heading)' }}>
                {item.stat}
              </div>
              <p className="text-xs text-foreground-500 mb-4">{item.statLabel}</p>
              <h3 className="text-sm font-semibold text-foreground-900 mb-2">{item.title}</h3>
              <p className="text-xs text-foreground-600 leading-relaxed">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}